import { Meta } from './meta';
import type { StepProps } from '../utils';

export function StepForm(step: StepProps) {
    const Element = step.element as React.ComponentType;
    
    return (
        <>
            <Meta title={step.title} />
            <Element />
        </>
    );
}
